(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const dismissedKey = 'patchaid:alia-side-tab-dismissed';
  const closeButtonId = 'patchaid-alia-side-tab-dismiss';
  const rootSelector = '[id^="alia-root-"]';

  let observedRoot;
  let rootStyleObserver;

  function getAliaRoot() {
    return document.querySelector(rootSelector);
  }

  function isSideTab(root) {
    const button = root?.querySelector('button');

    return (
      root &&
      root.style.transform.includes('rotate(-90deg)') &&
      button &&
      button.querySelector('svg') &&
      /off/i.test(button.textContent)
    );
  }

  function removeCloseButton() {
    document.getElementById(closeButtonId)?.remove();
  }

  function hideSideTab(root) {
    if (root.style.display !== 'none') {
      root.style.setProperty('display', 'none', 'important');
    }
    removeCloseButton();
  }

  function placeCloseButton(root) {
    if (!mobileQuery.matches) {
      removeCloseButton();
      return;
    }

    if (sessionStorage.getItem(dismissedKey)) {
      hideSideTab(root);
      return;
    }

    const rect = root.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    let closeButton = document.getElementById(closeButtonId);
    if (!closeButton) {
      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.id = closeButtonId;
      closeButton.setAttribute('aria-label', 'Dismiss 40% off offer for this session');
      closeButton.title = 'Dismiss offer';
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        sessionStorage.setItem(dismissedKey, 'true');
        hideSideTab(root);
      });
      document.body.append(closeButton);
    }

    // The Alia X icon sits at the top end of its rotated side tab. Keep the
    // visual unchanged while expanding that icon's effective touch area to 44px.
    closeButton.style.cssText = [
      'position:fixed',
      `left:${Math.max(0, rect.left)}px`,
      `top:${Math.max(0, rect.top)}px`,
      `width:${Math.max(44, rect.width)}px`,
      'height:44px',
      'margin:0',
      'padding:0',
      'border:0',
      'background:transparent',
      'color:transparent',
      'cursor:pointer',
      'z-index:2147483647',
      '-webkit-tap-highlight-color:transparent'
    ].join(';');
    closeButton.onfocus = () => {
      closeButton.style.outline = '2px solid #000';
      closeButton.style.outlineOffset = '-2px';
    };
    closeButton.onblur = () => {
      closeButton.style.outline = 'none';
    };
  }

  function syncSideTab() {
    const aliaRoot = getAliaRoot();
    if (aliaRoot && aliaRoot !== observedRoot) {
      rootStyleObserver?.disconnect();
      observedRoot = aliaRoot;
      rootStyleObserver = new MutationObserver(syncSideTab);
      rootStyleObserver.observe(aliaRoot, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    if (isSideTab(aliaRoot)) {
      placeCloseButton(aliaRoot);
    } else {
      removeCloseButton();
    }
  }

  function start() {
    syncSideTab();
    new MutationObserver(syncSideTab).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', syncSideTab);
    mobileQuery.addEventListener?.('change', syncSideTab);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
